const ITEMS = ["Worship Leader", "Songwriter", "Speaker", "Coach", "Serving the Local Church"];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="overflow-hidden border-b border-ink/10 py-5 md:py-7 select-none"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="font-spartan font-extrabold uppercase tracking-tight text-3xl md:text-5xl px-6 md:px-10 text-outline"
              >
                {item}
                <span className="text-ink/20 pl-6 md:pl-10">·</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
